module.exports = __webpack_public_path__ + "img/do.06e1cfe.svg";